import React from 'react';
import Labels from '../Labels';

export default class ErrorComponent extends React.Component {
    constructor(props) {
        super(props);
        global.page = this;
        this.error = typeof props.error === "object" && props.error != null ? props.error : null;
        this.state = {
            code: typeof this.error.status === "number" ? this.error.status : 400,
            body: null
        };
    }

    componentDidMount() {
        try {
            if (this.error != null && typeof this.error.text === "function")
                this.error.text().then((t) => {
                    this.setState({ body: t })
                });
            else
                this.setState({ body: null });
        } catch (e) {
            this.setState({ body: null });
        }
    }



    render() {
        return <div>
            <div style={{ padding: 20, fontSize: 25, fontWeight: "bold", backgroundColor: "rgb(255 217 217)", color: "#6f0707", marginBottom: 20, borderRadius: 10 }}>{Labels.GetLabel("error.msg")}</div>
            <div style={{ fontSize: 25, margin: 10 }}>{Labels.GetLabel("error.code")} <b>{this.state.code}</b></div>
            {this.state.body != null && typeof this.state.body === "string" && this.state.body.length > 0 ? <div style={{ padding: 10, fontSize: 8, border: "1px solid rgb(240,240,240)" }}>{this.state.body}</div> : null}
        </div>
    }
}